"use client";
import { useSharedData } from "bossjob-remote/dist/hooks";
import { getCookie } from "helpers/cookies";
import { useEffect } from "react";
import { fetchUtm } from "./services";
const UTM = (props) => {
  const me = useSharedData("ME");
  const { utm_source, utm_medium, utm_campaign, utm_content } = props;
  useEffect(() => {
    if (!(utm_source && utm_medium && utm_campaign && utm_content)) {
      return;
    }
    const sessionid = getCookie("sessionid");
    if (!sessionid) {
      fetchUtm({ utm_source, utm_medium, utm_campaign, utm_content });
    } else if (me?.id) {
      fetchUtm({ utm_source, utm_medium, utm_campaign, utm_content, user_id: me.id });
    }
  }, [me]);

  return <></>;
};

export default UTM;
